import React from "react";
import logoImage from "../assets/images/MM-Final-Logo.webp";


export default function Footer({ setPage }) {
  const go = (p) => { setPage(p); window.scrollTo(0, 0); };

  return (
    <footer>
      <div className="footer-wrap">
        <div className="footer-main">
          <div className="footer-brand">
            <img src={logoImage} alt="Logo" className="footer-logo" />
            <p>Bringing ancient nutrition to modern comfort food. Handcrafted with love, served with pride. Guilt Kam Swad Full!</p>
          </div>
          <div className="footer-col">
            <h4>Quick Links</h4>
            <ul>
              <li><a href="#" onClick={() => go("about")}>About Us</a></li>
              <li><a href="#" onClick={() => go("millets")}>Our Millets</a></li>
              <li><a href="#" onClick={() => go("menu")}>Menu</a></li>
              <li><a href="#" onClick={() => go("contact")}>Order Now</a></li>
            </ul>
          </div>
          <div className="footer-col">
            <h4>Contact</h4>
            <ul>
              <li><a href="mailto:hello@milletmomos.com">hello@milletmomos.com</a></li>
              <li><a href="https://maps.google.com/?q=Hyderabad,+Telangana">Hyderabad, Telangana</a></li>
            </ul>
          </div>
          <div className="footer-col">
            <h4>Follow Us</h4>
            <ul>
              <li><a href="https://instagram.com/milletmomos">Instagram</a></li>
              <li><a href="https://facebook.com/milletmomos">Facebook</a></li>
              <li><a href="https://twitter.com/milletmomos">Twitter</a></li>
              <li><a href="https://youtube.com/milletmomos">YouTube</a></li>
            </ul>
          </div>
        </div>
        <div className="footer-bottom">
          <p>© 2026 MilletMomos. All rights reserved. Made with 🌾 and ❤️</p>
        </div>
      </div>
    </footer>
  );
}